import { createAction, props } from '@ngrx/store';
export const addSecuritiesInfo = createAction('[Securities] Add Securities Info', props());
